import { render, staticRenderFns } from "./contribute_form.vue?vue&type=template&id=9581d1b2&"
import script from "./contribute_form.vue?vue&type=script&lang=js&"
export * from "./contribute_form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports